import React from "react";
import { makeStyles, useTheme, SvgIcon } from "@material-ui/core";
import { Theme } from "../.themes";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";

type TStatusIndicator = {
  title: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  includedWithWrapper: {
    display: "flex",
  },
  includedWith: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    padding: 8,
    background: theme.palette?.info?.light || "#DDE8F9",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    ...theme.statusIndicator,
  },
}));

export default function StatusIndicator({ title }: TStatusIndicator) {
  const theme: Theme = useTheme();
  const classes = useStyles(theme);

  const icon = theme.icons?.statusIndicatorIcon ? (
    <SvgIcon color='primary' style={{ fontSize: 12 }} viewBox='0 0 12 12'>
      {theme.icons?.statusIndicatorIcon}
    </SvgIcon>
  ) : (
    <InfoRoundedIcon color='primary' />
  );

  return (
    <div className={classes.includedWithWrapper}>
      <div className={classes.includedWith}>
        {icon}
        <div>{title}</div>
      </div>
    </div>
  );
}
